import { Viewport } from '../../utils/viewport';

const viewport = new Viewport({ rootMargin: '1024px 0px', threshold: 0.5 });

class SliderPagination {
  constructor(el) {
    this.el = el;
    this.bullets = [];
    this.items = [...el.previousElementSibling.children];

    this.init();
  }

  init() {
    this.items.forEach((item, index) => {
      const bullet = document.createElement('span');
      this.bullets.push(bullet);
      this.el.appendChild(bullet);

      item.dataset.paginationIndex = index;

      viewport.observe(
        item,
        () => this.bullets[item.dataset.paginationIndex].classList.add('active'),
        () => this.bullets[item.dataset.paginationIndex].classList.remove('active')
      );
    });
  }
}

document.querySelectorAll('.slider-pagination').forEach((el) => new SliderPagination(el));